module.exports = __webpack_public_path__ + "702a3b0bd1de0a4076dfac6e73e3812b.png";